import { useState, type FC, useEffect, useRef } from 'react'

import { Text } from '@wartek-id/text-v1'
import { Textarea } from '@wartek-id/textarea'

import { IS_DEVELOPMENT } from 'app/KinerjaShared/constants/env'

type DialogConsentFormProps = {
  text?: string
  onChange?: (isValid: boolean) => void
}

export const DialogConsentForm: FC<DialogConsentFormProps> = ({
  text = 'Saya setuju untuk lanjut dengan data ini.',
  onChange,
}) => {
  const inputRef = useRef(null)
  const [textConsent, setTextConsent] = useState<string>('')
  const isValid = textConsent === text
  const isDirty = textConsent !== ''
  const isInvalid = !isValid && isDirty

  useEffect(() => {
    onChange?.(isValid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid])

  useEffect(() => {
    inputRef.current?.focus()
    inputRef.current?.scrollIntoView()
  }, [])

  return (
    <>
      <Text variant="body-lg" color="subdued">
        Mohon ketik kalimat ini pada kolom kalimat persetujuan:
      </Text>
      <div className="bg-blue-5 p-1 rounded">
        <Text
          variant="heading-sm"
          color="informational"
          className="select-none !text-blue-60"
        >
          {text}
        </Text>
      </div>

      <div className="!mt-5 w-80">
        <Text className="mb-1">Kalimat persetujuan</Text>
        <Textarea
          ref={inputRef}
          rows={3}
          placeholder="Ketik di sini."
          id="persetujuan"
          onChange={(event) => setTextConsent(event.target.value)}
          isInvalid={isInvalid}
          errorMessage={isInvalid && 'Mohon cek ejaan dan coba lagi.'}
          defaultValue={IS_DEVELOPMENT ? text : ''}
        />
      </div>
    </>
  )
}
